module.exports = __webpack_public_path__ + "img/095e624f246e71dd86dacd491a52d515.png";